import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "../styles/stripe-redirect.module.css";

const StripeRedirect = () => {
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();
  const location = useLocation();

  // Get session_id from URL query params
  const searchParams = new URLSearchParams(location.search);
  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (!sessionId) {
      navigate("/pricing");
      return;
    }

    // Start countdown and redirect
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // Redirect to success page with the session ID
          navigate("/dashboard/stripe-success", {
            state: { sessionId },
          });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [sessionId, navigate]);

  const handleManualRedirect = () => {
    navigate("/dashboard/stripe-success", {
      state: { sessionId },
    });
  };

  return (
    <div className={styles.redirectContainer}>
      <div className={styles.redirectCard}>
        <div className={styles.spinner}></div>
        <h1 className={styles.redirectTitle}>Payment Successful!</h1>
        <p className={styles.redirectMessage}>
          Redirecting you back to {"<Bramlo>"} in <strong>{countdown}</strong>{" "}
          seconds...
        </p>
        <button
          className={styles.redirectButton}
          onClick={handleManualRedirect}
        >
          Click here if you're not redirected automatically
        </button>
      </div>
    </div>
  );
};

export default StripeRedirect;
